import React from 'react';
import type { EvaluationItem } from '../../../../../types/course';
import FloatingLabelPill from '../shared/FloatingLabelPill';
import AnswerPill from '../shared/AnswerPill';
import SectionHeader from '../shared/SectionHeader';
import TrashButton from '../shared/TrashButton';

interface ItemEditorProps {
  item: Extract<EvaluationItem, { type: 'boolean_true_false' }>;
  onChange: (patch: Partial<Extract<EvaluationItem, { type: 'boolean_true_false' }>>) => void;
  onDelete: () => void;
  readOnly?: boolean;
}

export default function BooleanTrueFalseItem({ item, onChange, onDelete, readOnly }: ItemEditorProps) {
  const { question, correct_value } = item.config;

  return (
    <div className="flex flex-col gap-[31px] w-full">
      <SectionHeader title="True or False" />
      <FloatingLabelPill
        label="Statement"
        value={question}
        onChange={(v) => onChange({ config: { ...item.config, question: v } })}
        placeholder="Enter a statement (true or false)"
        size="xl"
        readOnly={readOnly}
        trailingIcon={!readOnly && <TrashButton onClick={onDelete} ariaLabel="Delete statement" />}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-[18px]">
        <AnswerPill
          value="True"
          staticLabel
          state={correct_value === true ? 'selected' : 'default'}
          onToggleCorrect={
            readOnly ? undefined : () => onChange({ config: { ...item.config, correct_value: true } })
          }
        />
        <AnswerPill
          value="False"
          staticLabel
          state={correct_value === false ? 'selected' : 'default'}
          onToggleCorrect={
            readOnly ? undefined : () => onChange({ config: { ...item.config, correct_value: false } })
          }
        />
      </div>
    </div>
  );
}
